module.exports = __webpack_public_path__ + "img/icon_category_03_w.018bc4d1.svg";